export default __webpack_public_path__ + "static/media/093-move-1.b515f1b7.png";